import { Metamodel } from 'app/model/base/model';

import { ActionConstants, ValidationConstants } from 'shell-models-lib';
import { DataFlowUserDefinedArgument } from './dataflow-expression-utilities';
import { DataFlowFunction } from './dataflow-function';

@Metamodel.model({
    name: 'udfFunction',
    display: [stringResources.UserDefinedFunction, stringResources.UserDefinedFunctions],
    reusable: true,
    referable: true,
    constraints: {
        name: {
            required: true,
            pattern: ValidationConstants.factoryEntityNameValidator,
            uniqueModelName: true
        }
    },
    accessPublishConstraint: {
        writeResource: {
            action: ActionConstants.dataFlowsWrite
        },
        deleteResource: {
            action: ActionConstants.dataFlowsDelete
        }
    }
})
export class UserDefinedFunction extends DataFlowFunction {
    public functionArgs: DataFlowUserDefinedArgument[] = [];
    public index?: number;
}
